export const APP_DATE_FORMAT = "DD/MM/YY HH:mm";
export const APP_DATE_ONLY_FORMAT = "DD/MM/YY";
export const APP_HOUR_FORMAT = "HH:mm";
export const APP_DATE_ONLY_FORM_FORMAT = "YYYY-MM-DD";
export const APP_TIMESTAMP_FORMAT = "DD/MM/YY HH:mm:ss";
export const APP_LOCAL_DATE_FORMAT = "DD/MM/YYYY";
export const APP_LOCAL_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm";
export const APP_LOCAL_DATETIME_FORMAT_Z = "YYYY-MM-DDTHH:mm Z";
export const APP_WHOLE_NUMBER_FORMAT = "0,0";
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = "0,0.[00]";
export const messages = {
    DATA_ERROR_ALERT: "Internal Error",
};
export const ITEMS_PER_PAGE = 20;
//# sourceMappingURL=constants.js.map